// Models
import { EntityDetails } from 'app/modules/entitiesOld/models';

// Helpers

// Caution: Do not change, as it would cause errors in dropdown selector for EntityList table
export const ENTITIES_PAGE_LIMIT = 25;

export const EMPTY_ENTITY: EntityDetails = {
  id: -1,
  risk_score: 0,
  name_readable: '',
  status: '',
  internal_entity_type: '',
  created_at: '',
  external_id: '',
  entity_type: 'USER',
  type: '',
  paginated_alerts: {
    count: 0,
    alerts: [],
  },
  tags: [],
  comments: [],
  whitelists: {
    id: -1,
    external_id: '',
    active_whitelists: 0,
  },
  internal_status: '',
  formatted_data: {},
};
